// extracted by mini-css-extract-plugin
export default {"modalDiv":"Modal_modalDiv__Ej-Na","modal1":"Modal_modal1__NUjmw","myModal":"Modal_myModal__q3D9j"};